module.exports = {
	apiBaseUrl: "https://localhost:9999/"
}
